function objectWithoutProperties(obj, exclude) {
  var target = {}
  for (var k in obj)
    if (
      Object.prototype.hasOwnProperty.call(obj, k) &&
      exclude.indexOf(k) === -1
    )
      target[k] = obj[k]
  return target
}
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-onboarding-mode flex-row wp-8 mx-auto" },
    _vm._l(_vm.cards, function(ref) {
      var id = ref.id
      var title = ref.title
      var rest = objectWithoutProperties(ref, ["id", "title"])
      var card = rest
      return _c(
        "div",
        {
          key: card.id,
          staticClass: "mode-card mx-2 b-1 br pt-4 pb-5 px-5 white-bkg"
        },
        [
          _vm.isRecommandedMode(id)
            ? _c("div", { staticClass: "flex-row wp-10 jc-center" }, [
                _c(
                  "span",
                  { staticClass: "mode-card__label fs-2 px-2 semibold" },
                  [_vm._v(_vm._s(_vm.$l10n.__("Recommandé")))]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "flex-column hp-10" }, [
            _c("div", { staticClass: "header flex-column ai-center bb-1" }, [
              _c("h3", { staticClass: "title m-0" }, [_vm._v(_vm._s(title))]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "subtitle fs-3 m-0 acenter gray-60 py-3" },
                [_vm._v(_vm._s(card.subtitle))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content mt-3 flex-column" },
              _vm._l(card.features, function(ref, index) {
                var icon = ref.icon
                var title = ref.title
                var description = ref.description
                return _c("div", { key: index, staticClass: "flex-row mb-4" }, [
                  _c("i", { class: icon }),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-column ml-3" }, [
                    _c("h3", { staticClass: "fs-3 m-0" }, [
                      _vm._v(_vm._s(title))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "grey my-0" }, [
                      _vm._v(_vm._s(description))
                    ])
                  ])
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "action flex-column ai-center" },
              [
                _c("CompassLink", {
                  attrs: {
                    label: card.action.moreDetails.label,
                    link: card.action.moreDetails.href,
                    target: "_blank"
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "mt-3",
                  attrs: {
                    disabled: _vm.isDisabledMode(id),
                    label: card.action.select.label
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("validMode", { id: id, title: title })
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }